import { AlfredFooter } from '@terminal/components/alfred-footer/AlfredFooter';
import { TrackingMetadata } from '@terminal/services/tracking/posthog/constants';
import clsx from 'clsx';
import React from 'react';

import styles from './WithFooterWrapper.module.scss';

export interface WithFooterWrapperProps {
  children?: React.ReactNode;
  testId?: string;
  isWrappedComponentOpened?: boolean;
  className?: string;
  shouldHide?: boolean;
  trackingMetadata?: TrackingMetadata;
  fixedFooter?: boolean;
  autoFocus?: boolean;
}

export const WithFooterWrapper = ({
  children,
  testId,
  isWrappedComponentOpened = true,
  className,
  shouldHide = false,
  trackingMetadata,
  fixedFooter = false,
  autoFocus = false,
}: WithFooterWrapperProps) => {
  const hasFooter = isWrappedComponentOpened && fixedFooter;

  return (
    <div className={styles.root} data-testid={testId}>
      <span
        className={clsx(styles.content, className, {
          [styles.contentWithFixedFooter]: hasFooter,
        })}
      >
        {children}
      </span>
      {isWrappedComponentOpened && (
        <AlfredFooter
          fixed={fixedFooter}
          shouldHide={shouldHide}
          trackingMetadata={trackingMetadata}
          autoFocus={autoFocus}
        />
      )}
    </div>
  );
};
